<template>
    <div class="scandetail" :style="{background:'url('+bgimgurl+') no-repeat',width: '100%', height: mh+'rem', 'background-size': '100%'}">
        <!-- <div class="cen">
            <img @click="godetail()" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20240430/1714439383/215389.png" alt="">
            <img @click="handleinfo()" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20240430/1714439383/256657.png" alt="">
        </div> -->
        <div class="footer" :style="{background: color}">
            <div>
                <span>{{detail.score||0}}</span>
                累计打卡
            </div>
            <div class="check"  @click="handleSteps">
                
            </div>
            

            <div>
                <div>
                    <span>{{freenum}}</span>
                    抽奖机会
                </div>
                <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20240423/1713854810/918909.png" alt @click="goluckdraw"/>
            </div>
        </div>
    </div>
</template>

<script>
import "./index.less";
import { ImagePreview } from 'vant';

export default {
    data() {
        return {
            activity_id: '',
            loading: false,
            detail: {},
            freenum: 0,
            code: "",
            bgimgurl: '',
            mh: 16,
            color: '#0070FF'
        };
    },
    mounted() {
        this.activity_id = this.$route.params.acid
        this.init();
    },
    methods: {
        init() {
            let that = this
            this.$api.activity.taskList({activity_id:this.activity_id}).then(res => {
                if(res.status==200){
                    let { short_desc } = res.data
                    let arr = []
                    if(short_desc.length>0){
                        arr = JSON.parse(short_desc)
                        this.bgimgurl = arr[3]
                        this.color = arr[4]
                        this.getImg(this.bgimgurl).then(res=>{
                            var width = res.width;
                            var height = (res.height*7.5)/width;
                            that.mh = Math.round(height)
                        })
                        
                    }
                    
                }
            });
            let params = { acid: this.activity_id };
            this.$api.activity.usercheckinfo(params).then(res => {
                if(res.status==200){
                    this.detail = res.data
                    if(this.detail.score) {
                        this.freenum = 0
                        let num = Math.floor(this.detail.score*1/this.detail.step)
                        console.log(num,'num')
                        if(num>0) this.freenum = (num - this.detail.drawnum) > this.detail.nums ? this.detail.nums : num           
                    }
                }
            });

            if(this.$route.params.sub_aid) {
                this.code = this.$route.params.sub_aid
                this.checkInRequest();
            }
        },
        async getImg(img) {
            return new Promise((resolve, reject) => {
                var temImg = new Image()
                temImg.src = img
                if(temImg.complete) {
                    const { width, height } = temImg
                    resolve({width, height})
                } else {
                    temImg.onload = function() {
                        const { width, height } = temImg
                        resolve({width, height})
                    }
                }
                
            })
        },
        handleSteps() {
            let that = this;
            this.loading = true;
            if(!this.$wechat.bridge.isWeChat){

                this.$dialog.alert({
                    title:"提示",
                    message:"请在微信中打开连接"
                })
                this.loading = false;
                return ;
            }

            this.$wechat.scanQRCode().then((res) => {
                if (res) {
                    this.code = res
                    this.checkInRequest();
                } else {
                    this.loading = false;

                }
            }, () => {
                this.loading = false;
            })
        },
        checkInRequest: function () {
            this.$api.activity.taskCheckin({
                type: 1,
                code: this.code,
                activity_id: this.activity_id
            }).then(res => {
                if(res.status ==200) {
                    this.$toast.success("打卡成功");
                } else {
                    this.$toast.fail(res.data.message);
                }
                this.init();
            })
        },
        goluckdraw() {
            if(this.freenum < 1) {
                this.$toast.fail("您还没有抽奖机会，快去点位打卡吧");
                return
            }
            this.$router.push({name:'scanCoupon',params:{'acid':this.activity_id}})
        },
        godetail() {
            window.location.href = "https://oss.mcloud.moveclub.cn/alphamovecloud/20240430/1714439383/活动日程.jpg"
        },
        handleinfo() {
            ImagePreview(['https://oss.mcloud.moveclub.cn/alphamovecloud/20240430/1714453838/311845.jpg']);
        }
    }
}
</script>